import { Routes } from '@angular/router';
import { ADMIN_ROUTES } from './admin/admin.routes';
import { AUTH_ROUTES } from './auth/auth.routes';
import { CMSPAGE_ROUTES } from './cmspage/cmspage.routes';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

export const routes: Routes = [
  ...CMSPAGE_ROUTES,
  ...ADMIN_ROUTES,
  ...AUTH_ROUTES,
  { path: '', redirectTo: 'admin', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent },
];
